import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import TheDiyActions from '@/components/v2/diy/TheDiyActions.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { DeliveryFeeType } from '@/helpers/entities/enums/v2/DeliveryFeeType';
import { AddressInputType } from '@/helpers/entities/enums/v2/AddressInputType';
import { TaxType } from '@/helpers/entities/enums/v2/TaxType';
import { LocationScope } from '@/helpers/entities/enums/v2/LocationScope';
import { ExpirationType } from '@/helpers/entities/enums/v2/ExpirationType';
import ActionButton from '@/components/action_button/Index.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import AppDetails from '@/plugins/graphql/queries/v2/ecommerce/app-details.gql';
import OperatingLeadTimeMixin from '@/helpers/vue_mixins/v2/OperatingLeadTimeMixin';
import { EcommerceAppModel } from '@/helpers/entities/models/EcommerceAppModel';
import { selectOptionBuilder, selectOptionBooleanBuilder } from '@/helpers/select_option_builder';
import CartSettingUpdate from '@/plugins/graphql/mutations/v2/ecommerce/cart-setting-update.gql';
import DeliveryAreaCities from '@/plugins/graphql/queries/v2/delivery-area-cities.gql';
import { successfulCreate, invalidType, requiredProperty, successfulUpdate, } from '@/helpers/mixins/LocalizationHelper';
import CartSettingFragment from '@/plugins/graphql/fragments/v2/ecommerce/cart-setting.gql';
import { required, numeric, minValue } from 'vuelidate/lib/validators';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { ChargeDeliveryFeeFrom } from '@/helpers/entities/enums/v2/ChargeDeliveryFeeFrom';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import AppBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import { AppBasicModel } from '@/helpers/entities/models/AppBasicModel';
import { Getter } from 'vuex-class';
import ResetPersistentMenu from '@/plugins/graphql/mutations/page-reset-persistent-menu.gql';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FetchShippingMethods from '@/plugins/graphql/queries/v3/fetch-shipping-methods.gql';
let CartSettingForm = class CartSettingForm extends mixins(mixins(FormMixin, RouterParamsAppMixin, DiyMixin, ViewportSizeMixin, SegmentAnalyticsMixin), CleverTapEventsMixin, FormValidationsMixin, OperatingLeadTimeMixin) {
    constructor() {
        super(...arguments);
        this.defaultAmount = 0;
        this.appDetails = null;
        this.deliveryFee = null;
        this.addressInput = AddressInputType.googleMapPin;
        this.digitalProduct = false;
        this.taxType = null;
        this.subcategorized = false;
        this.locationScope = LocationScope.local;
        this.chargeDeliveryFeeFrom = ChargeDeliveryFeeFrom.delivery_area_fee;
        this.enableFreeShippingAmount = false;
        this.freeShippingAmount = this.defaultAmount;
        this.enableMinTransactionAmount = false;
        this.minTransactionAmount = this.defaultAmount;
        this.recipients = [];
        this.additionalTax = null;
        this.expirationType = null;
        this.expiration = 0;
        this.shoulderConvenienceFee = false;
        this.shoulderProcessingFee = false;
        this.inputConfirmation = false;
        this.freeShippingOption = [];
        this.selectedOptions = [];
        this.shippingOptions = [];
        this.enableOperatingHours = false;
        this.enableLeadTime = false;
        this.leadTimeDays = 1;
        this.hours = [
            '12:00 AM',
            '1:00 AM',
            '2:00 AM',
            '3:00 AM',
            '4:00 AM',
            '5:00 AM',
            '6:00 AM',
            '7:00 AM',
            '8:00 AM',
            '9:00 AM',
            '10:00 AM',
            '11:00 AM',
            '12:00 PM',
            '1:00 PM',
            '2:00 PM',
            '3:00 PM',
            '4:00 PM',
            '5:00 PM',
            '6:00 PM',
            '7:00 PM',
            '8:00 PM',
            '9:00 PM',
            '10:00 PM',
            '11:00 PM',
        ];
        this.openingTime = '';
        this.closingTime = '';
        this.allowClosingHoursOrder = null;
        this.allowClosingHoursOrderOptions = [
            {
                text: 'Close Store',
                value: false,
                tooltipText: 'Stop accepting orders and display a message that the store is closed.',
            },
            {
                text: 'Accept Advanced Orders',
                value: true,
                tooltipText: 'Allow customers to place orders for a future date and time while the store is closed.',
            },
        ];
        this.feePayload = {
            val: null,
            feeType: null,
        };
    }
    get allShippingOption() {
        return this.selectedOptions.length === this.shippingOptions.length;
    }
    get selectSomeShippingoption() {
        return this.selectedOptions.length > 0 && !this.allShippingOption;
    }
    get icon() {
        if (this.allShippingOption)
            return 'check_box';
        if (this.selectSomeShippingoption)
            return 'indeterminate_check_box';
        return 'check_box_outline_blank';
    }
    toggle() {
        this.$nextTick(() => {
            if (this.allShippingOption) {
                this.selectedOptions = [];
            }
            else {
                this.selectedOptions = [...this.shippingOptions];
            }
        });
    }
    get shoulderFeeTypes() {
        return [
            { value: true, text: `Enable` },
            { value: false, text: `Disable` },
        ];
    }
    get isSelectedAll() {
        return this.freeShippingOption.length === this.shippingOptions.length;
    }
    selectAllOptions() {
        if (this.isSelectedAll) {
            this.freeShippingOption = [];
        }
        else {
            this.freeShippingOption = this.shippingOptions;
        }
    }
    processingFeeLabel() {
        if (this.$route.params.key === Bundle.Insurance) {
            return 'Processing Fee';
        }
        return 'GLife Processing Fee';
    }
    onChange(val, feeType) {
        this.inputConfirmation = true;
        this.feePayload.val = val;
        this.feePayload.feeType = feeType;
    }
    onConfirm() {
        this.inputConfirmation = false;
    }
    onCancel() {
        this.inputConfirmation = false;
        if (this.feePayload.feeType === 'processing') {
            this.shoulderProcessingFee = !this.feePayload.val;
        }
        if (this.feePayload.feeType === 'convenience') {
            this.shoulderConvenienceFee = !this.feePayload.val;
        }
    }
    async resetPersistentMenu() {
        const self = this;
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: ResetPersistentMenu,
            variables: {
                input: {
                    appUuid: this.appUuid,
                },
            },
        })
            .then(() => {
            const msg = successfulUpdate('Persistent Menu');
            self.successNotification(msg);
            self.clearPersistentErrorNotification();
        })
            .catch((e) => {
            self.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            self.hideConfirmationDialog();
        });
    }
    get deliveryFeeTypes() {
        return [
            selectOptionBuilder(DeliveryFeeType.default, 'No'),
            selectOptionBuilder(DeliveryFeeType.custom, 'Yes'),
        ];
    }
    get digitalProductTypes() {
        return [selectOptionBooleanBuilder(true, 'Yes'), selectOptionBooleanBuilder(false, 'No')];
    }
    get hintForDeliveryFeeType() {
        if (this.deliveryFee === DeliveryFeeType.custom) {
            return `Set specific areas that you will cater on Delivery Areas menu`;
        }
        return `Delivery Areas will be based on the PSGC (Philippine Standard Geographic Code)`;
    }
    get hintForChargeDeliveryFeeFrom() {
        if (this.chargeDeliveryFeeFrom === ChargeDeliveryFeeFrom.delivery_area_fee) {
            return `Set Delivery area Fee on Delivery Areas menu`;
        }
        return ``;
    }
    get addressInputTypes() {
        return [selectOptionBuilder(AddressInputType.formInput, 'Form Input')];
    }
    get taxTypes() {
        return [
            selectOptionBuilder(TaxType.absolute, 'Absolute'),
            selectOptionBuilder(TaxType.percentage),
        ];
    }
    get locationScopes() {
        return [
            selectOptionBuilder(LocationScope.local),
        ];
    }
    get chargeDeliveryFeeFromTypes() {
        return [
            selectOptionBuilder(ChargeDeliveryFeeFrom.delivery_area_fee),
            selectOptionBuilder(ChargeDeliveryFeeFrom.shipping_option_fee),
        ];
    }
    get expirationTypes() {
        return [
            selectOptionBuilder(ExpirationType.seconds),
            selectOptionBuilder(ExpirationType.minutes),
            selectOptionBuilder(ExpirationType.hours),
            selectOptionBuilder(ExpirationType.days),
            selectOptionBuilder(ExpirationType.weeks),
            selectOptionBuilder(ExpirationType.months),
        ];
    }
    get showChargeDeliveryFeeFrom() {
        return this.deliveryFee === DeliveryFeeType.custom;
    }
    get taxTypeIsPercentage() {
        return this.taxType === TaxType.percentage;
    }
    get recipientsErrors() {
        const errors = [];
        if (!this.$v.recipients.$dirty) {
            return errors;
        }
        if (this.$v.recipients.$anyError) {
            const msg = invalidType('Recipients');
            errors.push(msg);
        }
        return errors;
    }
    get expirationErrors() {
        const errors = [];
        const label = 'Expiration';
        if (!this.$v.expiration.$dirty) {
            return errors;
        }
        if (!this.$v.expiration.required && !!this.expirationType) {
            const msg = requiredProperty(label);
            errors.push(msg);
        }
        if (!this.$v.expiration.numeric && !!this.expirationType) {
            const msg = invalidType(label);
            errors.push(msg);
        }
        return errors;
    }
    get minTransactionErrors() {
        const errors = [];
        if (!this.$v.minTransactionAmount.$dirty) {
            return errors;
        }
        if (!this.$v.minTransactionAmount.required && this.enableMinTransactionAmount) {
            const msg = requiredProperty('Minimum Transaction Amount');
            errors.push(msg);
        }
        return errors;
    }
    get freeShippingErrors() {
        const errors = [];
        if (!this.$v.freeShippingAmount.$dirty) {
            return errors;
        }
        if (!this.$v.freeShippingAmount.required && this.enableFreeShippingAmount) {
            const msg = requiredProperty('Free Shipping Amount');
            errors.push(msg);
        }
        return errors;
    }
    get additionalTaxErrors() {
        const errors = [];
        if (!this.$v.additionalTax.$dirty) {
            return errors;
        }
        if (!this.$v.additionalTax.required && !!this.taxType) {
            const msg = requiredProperty('Additional Tax');
            errors.push(msg);
        }
        return errors;
    }
    get openingTimeErrors() {
        const errors = [];
        if (!this.$v.openingTime.$dirty) {
            return errors;
        }
        if (!this.$v.openingTime.required) {
            const msg = requiredProperty('Opening Time');
            errors.push(msg);
        }
        return errors;
    }
    get allowClosingHoursOrderErrors() {
        const errors = [];
        if (!this.$v.allowClosingHoursOrder.$dirty) {
            return errors;
        }
        if (!this.$v.allowClosingHoursOrder.required) {
            const msg = requiredProperty('Closing Hours Handler');
            errors.push(msg);
        }
        return errors;
    }
    get closingTimeErrors() {
        const errors = [];
        if (!this.$v.closingTime.$dirty) {
            return errors;
        }
        if (!this.$v.closingTime.required) {
            const msg = requiredProperty('Closing Time');
            errors.push(msg);
        }
        return errors;
    }
    get leadTimeErrors() {
        const errors = [];
        if (!this.$v.leadTimeDays.$dirty) {
            return errors;
        }
        if (!this.$v.leadTimeDays.required) {
            const msg = requiredProperty('Lead Time');
            errors.push(msg);
        }
        if (!this.$v.leadTimeDays.numeric) {
            const msg = 'Lead Time should be a number';
            errors.push(msg);
        }
        if (!this.$v.leadTimeDays.minValue) {
            const msg = 'Lead Time should be greater than 0';
            errors.push(msg);
        }
        return errors;
    }
    onAppDetailsChanged(val) {
        if (val) {
            const { additionalTaxType, additionalTax, addressInputType, digitalProduct, cartRequiredAmount, deliveryFeeType, expiration, expirationDateType, freeShippingAmount, locationScope, chargeDeliveryFeeFrom, subcategorized, } = val.setting;
            this.addressInput = addressInputType || AddressInputType.googleMapPin;
            this.deliveryFee = deliveryFeeType;
            this.locationScope = locationScope || LocationScope.local;
            this.chargeDeliveryFeeFrom = chargeDeliveryFeeFrom || ChargeDeliveryFeeFrom.delivery_area_fee;
            this.subcategorized = subcategorized;
            this.expiration = expiration;
            this.expirationType = expirationDateType;
            this.recipients = val.setting.recipientAsTags();
            this.digitalProduct = digitalProduct;
            if (additionalTaxType) {
                this.taxType = additionalTaxType;
                this.additionalTax = additionalTax;
            }
            if (freeShippingAmount) {
                this.enableFreeShippingAmount = true;
            }
            this.freeShippingAmount = freeShippingAmount || this.defaultAmount;
            // Cart required amount default value is zero
            if (cartRequiredAmount > 0) {
                this.enableMinTransactionAmount = true;
            }
            this.minTransactionAmount = cartRequiredAmount;
        }
    }
    onOperatingHoursDataChange(data) {
        if (data) {
            this.setOperatingData(data);
        }
    }
    onLeadTimeDataChange(data) {
        if (data) {
            this.setLeadTimeData(data);
        }
    }
    onShippingFeeChanged(val) {
        if (!val) {
            this.freeShippingAmount = this.defaultAmount;
        }
    }
    onMinTransactionChanged(val) {
        if (!val) {
            this.minTransactionAmount = this.defaultAmount;
        }
    }
    get isInsurance() {
        return this.bundleKey === Bundle.Insurance;
    }
    async onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            await this.update()
                .then(() => {
                if (!this.diy) {
                    const msg = successfulCreate('Checkout Setting');
                    this.cartSettingAction('SUBMIT EDIT');
                    this.successNotification(msg);
                }
                else {
                    this.segmentTrack('DIY Step 3 - Customize App Checkout Settings', {
                        additionalTax: this.additionalTax,
                        additionalTaxType: this.taxType,
                        expiration: Number(this.expiration),
                        expirationDateType: this.expirationType,
                        locationScope: this.locationScope,
                        chargeDeliveryFeeFrom: this.chargeDeliveryFeeFrom,
                        deliveryFeeType: this.deliveryFee,
                        addressInputType: this.addressInput,
                        digitalProduct: this.digitalProduct,
                        subcategorized: this.subcategorized,
                        freeShippingRequiredAmount: this.freeShippingAmount,
                        requiredAmount: this.minTransactionAmount,
                    });
                }
                this.successFormSubmission();
            })
                .catch((e) => {
                this.errorNotification(e.message);
            })
                .finally(() => {
                this.requestDone();
            });
        }
    }
    async update() {
        const cartSettingUuid = this.appDetails?.setting.uuid;
        // Add 2nd mutation
        try {
            // First mutation
            const firstMutation = this.$apollo.mutate({
                mutation: CartSettingUpdate,
                variables: {
                    input: {
                        appUuid: this.appUuid,
                        additionalTax: this.additionalTax,
                        additionalTaxType: this.taxType,
                        expiration: Number(this.expiration),
                        expirationDateType: this.expirationType,
                        locationScope: this.locationScope,
                        chargeDeliveryFeeFrom: this.chargeDeliveryFeeFrom,
                        deliveryFeeType: this.deliveryFee,
                        addressInputType: this.addressInput,
                        subcategorized: this.subcategorized,
                        freeShippingRequiredAmount: this.freeShippingAmount,
                        requiredAmount: this.minTransactionAmount,
                        emailNotifRecipient: this.recipients.join(','),
                        digitalProduct: this.digitalProduct,
                        shoulderConvenienceFee: this.shoulderConvenienceFee,
                        shoulderProcessingFee: this.shoulderProcessingFee,
                        shippingOptions: this.selectedOptions,
                    },
                },
                update(cache, { data }) {
                    const { cartSetting } = data.ecommerceCartSettingUpdate;
                    cartSetting.uuid = cartSettingUuid; // Preserve UUID
                    cache.writeFragment({
                        id: cartSettingUuid,
                        fragment: CartSettingFragment,
                        data: cartSetting,
                        fragmentName: 'CartSetting',
                    });
                },
                refetchQueries: [
                    {
                        query: DeliveryAreaCities,
                        variables: {
                            appUuid: this.appUuid,
                            regionCode: null,
                        },
                    },
                ],
            });
            // Second mutation
            const form = {
                appUuid: this.appUuid,
                enableLeadTime: this.enableLeadTime,
                enableOperatingHours: this.enableOperatingHours,
                leadTimeValue: this.enableLeadTime ? this.leadTimeDays.toString() : null,
                openingHour: this.openingTime,
                closingHour: this.closingTime,
                allowClosingHoursOrder: this.allowClosingHoursOrder,
            };
            const secondMutation = this.updateOperatingAndLeadTime(form);
            // Execute both mutations in parallel
            await Promise.all([firstMutation, secondMutation]);
        }
        catch (error) {
            console.error('Error in update:', error);
        }
    }
    setOperatingData(data) {
        if (data && data.active) {
            this.enableOperatingHours = true;
        }
        this.openingTime = this.formatTime(data.openingHours);
        this.closingTime = this.formatTime(data.closingHours);
        this.allowClosingHoursOrder = data.allowClosingHoursOrder;
    }
    setLeadTimeData(data) {
        if (data && data.enable) {
            this.enableLeadTime = true;
        }
        this.leadTimeDays = data.leadTime;
    }
    mounted() {
        if (this.operatingHoursData) {
            this.setOperatingData(this.operatingHoursData);
        }
        if (this.leadTimeData) {
            this.setLeadTimeData(this.leadTimeData);
        }
    }
};
__decorate([
    Prop({ type: String, required: true })
], CartSettingForm.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Object, default: null })
], CartSettingForm.prototype, "operatingHoursData", void 0);
__decorate([
    Prop({ type: Object, default: null })
], CartSettingForm.prototype, "leadTimeData", void 0);
__decorate([
    Getter('requestOnFlight')
], CartSettingForm.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Watch('appDetails')
], CartSettingForm.prototype, "onAppDetailsChanged", null);
__decorate([
    Watch('operatingHoursData')
], CartSettingForm.prototype, "onOperatingHoursDataChange", null);
__decorate([
    Watch('leadTimeData')
], CartSettingForm.prototype, "onLeadTimeDataChange", null);
CartSettingForm = __decorate([
    Component({
        components: {
            PageTitle,
            FormHeader,
            ActionButton,
            NumericInput,
            TheDiyActions,
            ToggleConfirmationDialog,
            ConfirmationDialog,
        },
        apollo: {
            appDetails: {
                query: AppDetails,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    return new EcommerceAppModel(data.ecommerceAppDetails);
                },
            },
            app: {
                query: AppBasic,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    if (data && data.app) {
                        const { shoulderConvenienceFee, shoulderProcessingFee } = data.app;
                        this.shoulderConvenienceFee = shoulderConvenienceFee;
                        this.shoulderProcessingFee = shoulderProcessingFee;
                    }
                    return new AppBasicModel(data.app);
                },
                fetchPolicy: 'network-only',
            },
            shippingOptions: {
                query: FetchShippingMethods,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const { fetchAllShippingMethod } = data;
                    const shippingMethods = fetchAllShippingMethod.edges
                        .filter((item) => item.node.published)
                        .map((item) => ({
                        name: item.node.name,
                        value: item.node.uuid,
                        freeDelivery: item.node.freeDelivery,
                    }));
                    // Use the local shippingMethods variable, not this.shippingMethods
                    const freeDeliveryOptions = shippingMethods
                        ? shippingMethods.filter((option) => option.freeDelivery)
                        : [];
                    // If no free delivery options exist, select all shipping methods
                    this.selectedOptions =
                        freeDeliveryOptions.length > 0 ? freeDeliveryOptions : shippingMethods;
                    return shippingMethods;
                },
                fetchPolicy: 'network-only',
            },
        },
        validations() {
            const vm = this;
            let rules = {
                expiration: {},
                minTransactionAmount: {},
                freeShippingAmount: {},
                additionalTax: {},
                openingTime: {},
                closingTime: {},
                leadTimeDays: {},
                allowClosingHoursOrder: {},
            };
            if (vm.expirationType) {
                rules = {
                    ...rules,
                    expiration: {
                        required,
                        numeric,
                    },
                };
            }
            if (vm.taxType) {
                rules = {
                    ...rules,
                    additionalTax: {
                        required,
                    },
                };
            }
            if (vm.enableMinTransactionAmount) {
                rules = {
                    ...rules,
                    minTransactionAmount: {
                        required,
                    },
                };
            }
            if (vm.enableFreeShippingAmount) {
                rules = {
                    ...rules,
                    freeShippingAmount: {
                        required,
                    },
                };
            }
            if (vm.enableOperatingHours) {
                rules = {
                    ...rules,
                    openingTime: {
                        required,
                    },
                    closingTime: {
                        required,
                    },
                    allowClosingHoursOrder: {
                        required,
                    },
                };
            }
            if (vm.enableLeadTime) {
                rules = {
                    ...rules,
                    leadTimeDays: {
                        required,
                        numeric,
                        minValue: minValue(1),
                    },
                };
            }
            return rules;
        },
    })
], CartSettingForm);
export default CartSettingForm;
